import { useState } from "react";
import { HandCoins, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import { API, fmtErr } from "../lib/api";

const PRESETS = [2, 5, 10, 20];

export default function TipModal({ promoter, open, onClose }) {
  const [amount, setAmount] = useState(5);
  const [custom, setCustom] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open || !promoter) return null;

  const finalAmount = custom ? Number(custom) : amount;
  const valid = finalAmount > 0 && finalAmount <= 500;

  const sendTip = async () => {
    if (!valid || busy) return;
    setBusy(true);
    try {
      const { data } = await API.post("/tips/checkout", {
        promoter_id: promoter.id, amount: finalAmount,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(fmtErr(e));
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 px-6 backdrop-blur-sm"
      data-testid="tip-modal">
      <div className="card-neon w-full max-w-sm p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-neon-gold">
            <HandCoins size={20} weight="fill" />
            <div className="font-display text-sm font-black uppercase tracking-wider">Tip {promoter.handle}</div>
          </div>
          <button data-testid="tip-close-btn" onClick={onClose} className="text-zinc-500 hover:text-white"><X size={18} /></button>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-zinc-400">
          100% of your tip goes straight to {promoter.name}'s wallet.
        </p>
        <div className="mt-4 grid grid-cols-4 gap-2">
          {PRESETS.map((v) => (
            <button key={v} data-testid={`tip-amount-${v}`}
              onClick={() => { setAmount(v); setCustom(""); }}
              className={`rounded-xl border py-2.5 font-display text-sm font-black transition-colors duration-150 ${!custom && amount === v ? "border-neon-gold bg-neon-gold/15 text-neon-gold" : "border-white/10 text-zinc-400 hover:border-neon-gold/40"}`}>
              ${v}
            </button>
          ))}
        </div>
        <div className="mt-3 flex items-center rounded-xl border border-white/10 bg-black px-3 focus-within:border-neon-gold">
          <span className="text-neon-gold">$</span>
          <input data-testid="tip-custom-input" type="number" min="1" max="500" step="0.01"
            value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Custom amount"
            className="w-full bg-transparent px-2 py-2.5 text-sm outline-none" />
        </div>
        <button data-testid="tip-submit-btn" onClick={sendTip} disabled={!valid || busy}
          className="btn-neon mt-4 w-full !py-3 text-sm disabled:opacity-40">
          {busy ? "Opening checkout…" : `Send ${valid ? `$${finalAmount}` : ""} Tip`}
        </button>
      </div>
    </div>
  );
}
